import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { KARYON_TREE } from '../links.js'

export default function Navbar() {
  const [open, setOpen] = useState(false)
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1))
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 0)
      }
    } else {
      window.scrollTo({ top: 0 })
    }
  }, [pathname, hash])

  const sourceHref = pathname === '/karyon'
    ? KARYON_TREE
    : 'https://github.com/karyontech'

  return (
    <nav className="navbar">
      <Link to="/" className="logo">
        <img src="/logo.png" alt="KaryonTech" />
        <span>KaryonTech</span>
      </Link>
      <button
        className="nav-toggle"
        aria-label="Toggle navigation"
        onClick={() => setOpen(!open)}
      >
        <span></span><span></span><span></span>
      </button>
      <ul className={`nav-links${open ? ' open' : ''}`}>
        <li>
          <Link to="/" className={pathname === '/' ? 'active' : ''} onClick={() => { setOpen(false); window.scrollTo({ top: 0, behavior: 'smooth' }) }}>
            Home
          </Link>
        </li>
        <li><Link to="/#projects" onClick={() => setOpen(false)}>Projects</Link></li>
        <li>
          <Link to="/karyon" className={pathname === '/karyon' ? 'active' : ''} onClick={() => setOpen(false)}>
            Karyon
          </Link>
        </li>
        <li><Link to="/#join-us" onClick={() => setOpen(false)}>Join Us</Link></li>
        <li>
          <a href={sourceHref} className="btn btn-outline btn-nav">Source Code</a>
        </li>
      </ul>
    </nav>
  )
}
